import React from 'react';

/**
 * Drop-in-Ersatz für `<img className="… object-cover …">` in Listen, Karten und Kopfbildern (Marcel 13.10.2026):
 * das Bild ist KOMPLETT sichtbar (object-contain), die Ränder füllt dasselbe Bild unscharf. Passt das Bild exakt
 * in den Rahmen, ist vom Blur nichts zu sehen. `className` gilt für den Rahmen (Größe, Rundung, Hover-Transform),
 * alle übrigen img-Attribute (alt, loading, onError, style …) landen auf dem sichtbaren Bild.
 */
const BlurredImg: React.FC<React.ImgHTMLAttributes<HTMLImageElement>> = ({ className = '', src, alt = '', style, ...rest }) => {
  const frame = className.replace(/\bobject-(cover|contain|center|top|bottom|left|right)\b/g, '').replace(/\s+/g, ' ').trim();
  return (
    <span className={`relative block overflow-hidden ${frame}`} style={style} data-testid="blurred-img">
      <img src={src} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full scale-110 object-cover opacity-60 blur-md" loading="lazy"
        onError={(e) => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }} />
      <span className="absolute inset-0 bg-black/30" aria-hidden="true" />
      <img src={src} alt={alt} className="relative h-full w-full object-contain" {...rest} />
    </span>
  );
};

export default BlurredImg;
